import { Link } from "react-router-dom";
import { useClientBranding } from "../../providers/ClientBrandingProvider";
import ArchitectureDiagram from "./ui/ArchitectureDiagram";
import "./how-it-works.css";

export default function HowItWorksPage() {
  const { brandName, brandImageLight } = useClientBranding();

  return (
    <div className="gar-hiw">
      <header className="gar-hiw__nav">
        <Link to="/" className="gar-hiw__brand" aria-label={brandName}>
          <img src={brandImageLight} alt={brandName} />
        </Link>
        <p className="gar-hiw__tagline">
          Doc use cases · jobs feed · in-hub MCP · Chat API
        </p>
        <div className="gar-hiw__nav-actions">
          <Link className="gar-hiw__link" to="/">
            Product
          </Link>
          <Link className="gar-hiw__btn gar-hiw__btn--ghost" to="/login">
            Sign in
          </Link>
          <Link className="gar-hiw__btn gar-hiw__btn--primary" to="/register">
            Start free
          </Link>
        </div>
      </header>

      <ArchitectureDiagram />
    </div>
  );
}
